<div class="container-fluid">
	<app-alert-line [alertLineData]="alertLine"></app-alert-line>

    <ng-template [ngIf]="hasUser()">
		<div class="row">
			<div class="col-12">
				<h2>Liste des droits utilisateurs</h2>
			</div>
		</div>

		<div class="p-mb-3">
			<p-button type="button" icon="pi pi-chevron-left" (onClick)="prevUser()" [disabled]="isFirstPageUser()" styleClass="p-button-text"></p-button>
			<p-button type="button" icon="pi pi-refresh" (onClick)="resetUser()" styleClass="p-button-text"></p-button>
			<p-button type="button" icon="pi pi-chevron-right" (onClick)="nextUser()" [disabled]="isLastPageUser()" styleClass="p-button-text"></p-button>
		</div>
		<p-table [value]="datasUser"
			[columns]="columnsUser"
			sortField="username"
			[paginator]="true"
			[rows]="rowsUser"
			[showCurrentPageReport]="true"
			[(first)]="firstUser"
			currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} utilisateur(s)"
			[rowsPerPageOptions]="[10,25,50,100]"
			styleClass="p-datatable-striped"
			[autoLayout]=true
			#dt>
			<ng-template pTemplate="header" let-columnsUser>
				<tr>
					<th *ngFor="let col of columnsUser" [pSortableColumn]="col.sort">
						{{col.header}}
						<p-sortIcon [field]="col.sort"></p-sortIcon>
					</th>
					<th>Actions</th>
				</tr>
				<tr>
					<th>
						<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'username', 'contains')" placeholder="Recherche par identifiant" class="p-column-filter">
					</th>
					<th>
						<p-dropdown [options]="roleChoice" appendTo="body" (onChange)="dt.filter($event.value, 'role', 'equals')" styleClass="p-column-filter" placeholder="Choix du rôle" [showClear]="true">
							<ng-template let-option pTemplate="item">
								<span [class]="'company-badge status-'+option.value">{{option.label}}</span>
							</ng-template>
						</p-dropdown>
					</th>
					<th>
						<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'name', 'contains')" placeholder="Recherche par nom" class="p-column-filter">
					</th>
					<th>
						<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'firstname', 'contains')" placeholder="Recherche par prénom" class="p-column-filter">
					</th>
					<th>
						<p-dropdown [options]="userStateChoice" appendTo="body" (onChange)="dt.filter($event.value, 'global_active', 'equals')" styleClass="p-column-filter" placeholder="Choix de l'état" [showClear]="true">
							<ng-template let-option pTemplate="item">
								<span [class]="'company-badge status-'+option.value">{{option.label}}</span>
							</ng-template>
						</p-dropdown>
					</th>
					<th>
						<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'company_name', 'contains')" placeholder="Recherche par société" class="p-column-filter">
					</th>
					<th style="width:400px;">&nbsp;</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-usr let-usrs="datasUser">
				<tr>
					<td>
						<a [routerLink]="['/user-detail', usr['_id']]">{{usr.username}}</a>
					</td>
					<td>
						<span class="ls-role-user" *ngIf="usr['role']=='U'">Utilisateur</span>
						<span class="ls-role-engineer" *ngIf="usr['role']=='I'">Ingénieur</span>
						<span class="ls-role-admin" *ngIf="usr['role']=='A'">Administrateur</span>
					</td>
					<td>
						<span *ngIf="usr['name'] == ''">-</span>
						<span *ngIf="usr['name'] != ''">{{usr["name"]}}</span>
					</td>
					<td>
						<span *ngIf="usr['firstname'] == ''">-</span>
						<span *ngIf="usr['firstname'] != ''">{{usr["firstname"]}}</span>
					</td>
					<td>
						<span class="ls-state-active" *ngIf="usr['global_active'] == 'A'">Actif</span>
						<span class="ls-state-inactive" *ngIf="usr['global_active'] == 'D'">Désactivé</span>
						<span class="ls-state-inactive" *ngIf="usr['global_active'] == 'SD'">Société désactivée</span>
					</td>
                    <td>
						<span *ngIf="usr['company_name'] == '-'">-</span>
						<a [routerLink]="['/company-detail', usr['company_id']]" *ngIf="usr['company_name'] != '-'">{{usr["company_name"]}}</a>
					</td>
					<td>
						<button matTooltip="Editer" mat-raised-button type="button" class="btn btn-primary material-item" (click)="doEditUser(usr['_id'], usr.username, usr.company_name, usr.company_id, usr['global_active'])"><i class="material-icons md-24 icons">edit</i></button>
						&nbsp;
						<button *ngIf="usr['username'] != this.cookieService.get(this.constantsModule.cookieUser)" [disabled]="usr['global_active'] != 'A'" matTooltip="Réinitialiser le mot de passe" mat-raised-button type="button" class="btn btn-info material-item" (click)="doGenerateNewUserPassword(usr._id, usr.username)"><i class="material-icons md-24 icons">password</i></button>
						&nbsp;
						<button *ngIf="usr['username'] != this.cookieService.get(this.constantsModule.cookieUser)" [disabled]="usr['active']" matTooltip="Activer la société" mat-raised-button type="button" class="btn btn-success material-item" (click)="doActivateUser(usr._id)"><i class="material-icons md-24 icons">power</i></button>
						&nbsp;
						<button *ngIf="usr['username'] != this.cookieService.get(this.constantsModule.cookieUser)" [disabled]="!usr['active'] || usr['username'] == this.cookieService.get(this.constantsModule.cookieUser)" matTooltip="Désactiver la société" mat-raised-button type="button" class="btn btn-danger material-item" (click)="doDeactivateUser(usr._id)"><i class="material-icons md-24 icons">power_off</i></button>
					</td>
				</tr>
			</ng-template>
		</p-table>
		<br>
	</ng-template>

	<ng-template [ngIf]="!hasUser()">
		<div class="row">
			<div class="col-12">
				<h2>Pas d'utilisateur</h2>
				<p>Votre société ne contient pas d'utilisateur.</p>
			</div>
		</div>
	</ng-template>

	<div class="row">
		<div class="col-12">
			<button matTooltip="Mettre à jour les droits utilisateurs" mat-raised-button type="button" class="btn btn-primary material-item" (click)="doChangeUserRights()"><i class="material-icons md-24 icons">add_box</i> Mettre à jour les droits utilisateurs ...</button>
		</div>
	</div>
	<br><br>
	<hr>
	<ng-template [ngIf]="hasCompany()">
		<div class="row">
			<div class="col-12">
				<h2>Liste des droits sociétés</h2>
			</div>
		</div>

		<div class="p-mb-3">
			<p-button type="button" icon="pi pi-chevron-left" (onClick)="prevCompany()" [disabled]="isFirstPageCompany()" styleClass="p-button-text"></p-button>
			<p-button type="button" icon="pi pi-refresh" (onClick)="resetCompany()" styleClass="p-button-text"></p-button>
			<p-button type="button" icon="pi pi-chevron-right" (onClick)="nextCompany()" [disabled]="isLastPageCompany()" styleClass="p-button-text"></p-button>
		</div>
		<p-table [value]="datasCompany"
			[columns]="columnsCompany"
			sortField="name"
			[paginator]="true"
			[rows]="rowsCompany"
			[showCurrentPageReport]="true"
			[(first)]="firstCompany"
			currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} société(s)"
			[rowsPerPageOptions]="[10,25,50,100]"
			styleClass="p-datatable-striped"
			[autoLayout]=true
			#dt>
			<ng-template pTemplate="header" let-columnsCompany>
				<tr>
					<th *ngFor="let col of columnsCompany" [pSortableColumn]="col.sort">
						{{col.header}}
						<p-sortIcon [field]="col.sort"></p-sortIcon>
					</th>
					<th>Actions</th>
				</tr>
				<tr>
					<th>
						<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'name', 'contains')" placeholder="Recherche par nom" class="p-column-filter">
					</th>
					<th>
						<p-dropdown [options]="companyStateChoice" appendTo="body" (onChange)="dt.filter($event.value, 'active', 'equals')" styleClass="p-column-filter" placeholder="Choix de l'état" [showClear]="true">
							<ng-template let-option pTemplate="item">
								<span [class]="'customer-badge status-'+option.value">{{option.label}}</span>
							</ng-template>
						</p-dropdown>
					</th>
					<th>&nbsp;</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-company let-companies="datasCompany">
				<tr class="table-body-lines">
					<td>
						<a routerLink="/company-detail/{{company['_id']}}"> {{company["name"]}}</a>
					</td>
					<td>
						<span class="ls-state-active" *ngIf="company['active']">Active</span>
						<span class="ls-state-inactive" *ngIf="!company['active']">Désactivée</span>
					</td>
					<td>
						<button matTooltip="Editer" class="btn btn-primary material-item" type="button" mat-raised-button (click)="doRenameCompany(company['name'], company._id)"><i class="material-icons md-24 icons">edit</i></button>
						&nbsp;
						<button [disabled]="company['active']" matTooltip="Activer la société" class="btn btn-success material-item" type="button" mat-raised-button (click)="doActivateCompany(company._id)"><i class="material-icons md-24 icons">power</i></button>
						&nbsp;
						<button [disabled]="!company['active']"matTooltip="Désactiver la société" class="btn btn-danger material-item" type="button" mat-raised-button (click)="doDeactivateCompany(company._id)"><i class="material-icons md-24 icons">power_off</i></button>
					</td>
				</tr>
			</ng-template>
		</p-table>
		<br>
	</ng-template>

	<ng-template [ngIf]="!hasCompany()">
		<div class="row">
			<div class="col-12">
				<h2>Pas de sociétés</h2>
				<p>Aucune société n'a de droit sur ce dossier.</p>
			</div>
		</div>
	</ng-template>

	<div class="row">
		<div class="col-12">
			<button matTooltip="Mettre à jour les droits de société" mat-raised-button type="button" class="btn btn-primary material-item" (click)="doChangeCompanyRights()"><i class="material-icons md-24 icons">add_box</i> Mettre à jour les droits de société ...</button>
		</div>
	</div>
	<br><br>
</div>
